export default {
  previewSamplesBucket: 'wzrd-3585d-samples',
  samplesBucket: 'wzrd-3585d-samples-claimed',
  customImagesBucket: 'wzrd-3585d-custom-images',
  rendersBucket: 'wzrd-3585d-renders',
  audioReencodedBucket: 'wzrd-3585d-audio-reencoded',
  minNodesSpacingSd: 5,
  maxNodesSpacingSd: 15,
};
